import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import PermissionTableItem from "./PermissionTableItem/PermissionTableItem";
import { Permission } from "@src/Interfaces/Entity/Permission";
import { Values } from "Tools/Values";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";

interface IProps {
  permissions: Permission[];
  onEditButtonClick: (permission: Permission) => void;
}

export default class PermissionsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.permissions.map((permission: Permission) => (
                <PermissionTableItem
                    key={permission.id}
                    permission={permission}
                    onEditButtonClick={() => this.props.onEditButtonClick(permission)}
                />
            ))}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
